const domaine = 'ADMINISTRATION'

export const AJOUTER_ADMINISTRATION = `${domaine}/AJOUTER_ADMINISTRATION`
